module.exports = __webpack_public_path__ + "img/刘庆华.87a7aec5.png";